import Vue from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VCurrencyField from 'v-currency-field'
import VueApexCharts from 'vue-apexcharts'

// // Import TinyMCE
// import tinymce from 'tinymce/tinymce';

// // Default icons are required for TinyMCE 5.3 or above
// import 'tinymce/icons/default';

// // A theme is also required
// import 'tinymce/themes/silver';

// // Any plugins you want to use has to be imported
// import 'tinymce/plugins/paste';
// import 'tinymce/plugins/link';

// // Initialize the app
// tinymce.init({
//   selector: '#tiny',
//   plugins: ['paste', 'link']
// });

Vue.config.productionTip = false

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.use(VCurrencyField, {
  locale: 'de-DE',

  decimalLength: 2,

  autoDecimalMode: true,

  min: null,

  max: null,

  defaultValue: 0,

  valueAsInteger: false,

  allowNegative: true
})

new Vue({
  router,
  store,
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  vuetify,
  render: h => h(App)
}).$mount('#app')
